module.exports = __webpack_public_path__ + "media/images/WFC_Award_White-d50d58b191cde46d2dce6681db887d13.png";